export default __webpack_public_path__ + "static/media/AcFanMode.10889d9c.svg";